<template>
  <InvoiceTransmissionHeader>
    <EReportingPreview/>
  </InvoiceTransmissionHeader>
</template>

<script>

import EReportingPreview from "@/invoice-transmission/components/EReportingPreview.vue";
import InvoiceTransmissionHeader from "@/invoice-transmission/components/InvoiceTransmissionHeader.vue";

export default {
  name: 'FactureXEReportingView',
  components: {EReportingPreview, InvoiceTransmissionHeader}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
